// ----------------------------------------------------------------------

import { alpha } from '@mui/material/styles';

export default function Card(theme) {
  return {
    MuiCard: {
      variants: [
        // Glass Card Variant
        {
          props: { variant: 'glass' },
          style: {
            background: alpha('#fff', 0.15),
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            border: `1px solid ${alpha('#fff', 0.2)}`,
            boxShadow: `0 8px 32px ${alpha('#000', 0.1)}`,
            transition: 'all 0.3s ease',
            '&:hover': {
              background: alpha('#fff', 0.2),
              borderColor: alpha('#fff', 0.3),
              transform: 'translateY(-4px)',
              boxShadow: `0 12px 40px ${alpha('#000', 0.15)}`,
            },
          },
        },
        // Gradient Card Variant
        {
          props: { variant: 'gradient' },
          style: {
            background: theme.gradients?.primary || 'linear-gradient(135deg, #A8469B 0%, #569cd3 100%)',
            color: '#fff',
            boxShadow: `0 8px 24px ${alpha('#A8469B', 0.3)}`,
            '& .MuiCardContent-root': {
              color: '#fff',
            },
            '& .MuiTypography-root': {
              color: '#fff',
            },
          },
        },
        // Elevated Card (with hover lift)
        {
          props: { variant: 'elevated' },
          style: {
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: 'translateY(-8px)',
              boxShadow: `0 12px 32px ${alpha(theme.palette.primary.main, 0.2)}`,
            },
          },
        },
        // Outlined Gradient Card
        {
          props: { variant: 'outlinedGradient' },
          style: {
            background: 'transparent',
            border: '2px solid transparent',
            backgroundImage: `linear-gradient(${theme.palette.background.paper}, ${theme.palette.background.paper}), ${theme.gradients?.primary || 'linear-gradient(135deg, #A8469B 0%, #569cd3 100%)'}`,
            backgroundOrigin: 'border-box',
            backgroundClip: 'padding-box, border-box',
            transition: 'all 0.3s ease',
            '&:hover': {
              boxShadow: `0 8px 24px ${alpha('#A8469B', 0.2)}`,
            },
          },
        },
      ],
      styleOverrides: {
        root: {
          boxShadow: theme.customShadows.card,
          borderRadius: theme.shape.borderRadius * 2, // 12px default
          position: 'relative',
          zIndex: 0,
          backgroundColor: theme.palette.background.paper,
          transition: 'all 0.3s ease',
          // Default padding for cards without CardContent
          // Cards with CardContent will have padding handled by CardContent
          padding: theme.spacing(3),
          // Remove Card padding when CardContent is present (CardContent handles its own padding)
          '& > .MuiCardContent-root': {
            margin: theme.spacing(-3, -3, -3, -3),
            '&:first-of-type': {
              marginTop: 0,
            },
            '&:last-of-type': {
              marginBottom: 0,
            },
          },
          // Remove Card padding when CardHeader is present
          '& > .MuiCardHeader-root': {
            margin: theme.spacing(-3, -3, 0, -3),
            '&:first-of-type': {
              marginTop: 0,
            },
          },
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: 'h6' },
        subheaderTypographyProps: { variant: 'body2' },
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0),
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          '&:last-child': {
            paddingBottom: theme.spacing(3),
          },
        },
      },
    },
  };
}
